import { useState } from "react";

const Select = ({
  label,
  name,
  value,
  required = false,
  className = "",
  placeholder = "Select an option",
  options = [],
  onChangeHandler,
  onFocusHandler,
  error,
  disabled = false,
  ...rest
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const selectClass = `
    form-select
    ${className}
    ${error ? "is-invalid" : ""}
    ${isFocused ? "input-focused" : ""}
  `.trim();

  return (
    <div className="form-group">
      {label && (
        <label htmlFor={name} className="mb-1 mt-1 text-capitalize fw-semibold">
          {label}
          {required && <i className="text-danger ms-1">*</i>}
        </label>
      )}

      <select
        id={name}
        name={name}
        value={value || ""}
        onChange={onChangeHandler}
        onFocus={(e) => {
          setIsFocused(true);
          onFocusHandler && onFocusHandler(e);
        }}
        onBlur={() => setIsFocused(false)}
        disabled={disabled}
        className={selectClass}
        aria-invalid={rest["aria-invalid"]}
        {...rest}
      >
        <option value="" >{placeholder}</option>
        {options.map((item, idx) => (
          <option key={idx} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>

      {error && <div className="invalid-feedback d-block mt-1">{error}</div>}
    </div>
  );
};

export default Select;
